import { Box, Button, FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup, Typography } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form';
import { useMemo } from 'react';
import TitulosSelecionados from '../TitulosSelecionados';

export default function Step02() {

  const { control, getValues, } = useFormContext();

  const opcoesRadio = useMemo(() => [
    { value: "registrar pagamento", label: "Registrar pagamento", sublabel: '(Você informa manualmente a loja e o valor do pagamento)' },
    { value: "compensacao", label: "Compensação", sublabel: '(Registra pagamento através de compensação de títulos a receber)' },
  ], [])

  //funcoes manipuladoras
  const handleNext = getValues('funcoesAux.onNext')
  const handleBack = getValues('funcoesAux.onBack')
  const proibirRetroagir = getValues('funcoesAux.proibidoSelectTitulos')
  //

  return (
    <>
      <Grid container justifyContent='space-between' paddingTop={3}>
        <Grid size={{xs: 12, md: 6}}>
          <Box>
            <Typography variant='h6'>Escolha uma opção</Typography>

            <Controller
              control={control}
              rules={{ required: "Campo obrigatório" }}
              name='dados_pagamento.forma_pagamento'
              render={({ field }) => {
                return (
                  <FormControl {...field} style={{}}>
                    <FormLabel id="dadosPagamento">
                      <Typography variant='body1'>Como você deseja baixar os títulos selecionados?</Typography>
                    </FormLabel>

                    <RadioGroup
                      value={field.value}
                      defaultValue={getValues("dados_pagamento.forma_pagamento")}
                      style={{ gap: "16px", marginTop: "24px" }}
                    >
                      {
                        opcoesRadio.map((opcao, index) => (
                          <FormControlLabel key={index} value={opcao.value} control={<Radio />}
                            label={
                              <Box>
                                <Typography variant='body1' fontWeight={'bold'}>{opcao.label}</Typography>
                                {
                                  opcao.sublabel &&
                                  <Typography variant='caption'>{opcao.sublabel}</Typography>
                                }
                              </Box>
                            }
                          />
                        ))
                      }
                    </RadioGroup>
                  </FormControl>
                )
              }}
            />
          </Box>
        </Grid>

        <Grid size={{xs: 12, md: 6}}>
          <Box display="flex" justifyContent="flex-end">
            <TitulosSelecionados />
          </Box>
        </Grid>
      </Grid>

      <Box width={'100%'} display={'flex'} justifyContent={'flex-end'} gap={2} mt={2}>
        {
          !proibirRetroagir &&
          <Button
            onClick={handleBack}
          >
            Voltar
          </Button>
        }
        <Button
          variant="contained"
          onClick={handleNext}
        >
          Avançar
        </Button>
      </Box>
    </>
  )
}
